import { apiGet } from './client';
import type { EncounterDetail, EncounterParticipant, EncounterSummary } from './types';

export async function fetchRecentEncounters(limit = 25) {
  const data = await apiGet<{ encounters: EncounterSummary[] }>(`/encounters/recent?limit=${limit}`);
  return data.encounters;
}

export async function fetchEncounter(id: string) {
  const data = await apiGet<{ encounter: EncounterDetail }>(`/encounters/${encodeURIComponent(id)}`);
  return data.encounter;
}

export async function fetchEncounterParticipants(id: string) {
  const data = await apiGet<{ participants: EncounterParticipant[] }>(`/encounters/${encodeURIComponent(id)}/participants`);
  return data.participants;
}
